export const GET_ALL_TRIP_LIST = "GET_ALL_TRIP_LIST"
export const ALL_TRIP_LIST = "ALL_TRIP_LIST"
export const UPDATE_TRIP = "UPDATE_TRIP"
export const CREATE_TRIP = "CREATE_TRIP"
export const DONE_PROCESS = "DONE_PROCESS"
